<template lang="pug">
  .type-credits
    h3.f-0 Credits —
    .credits
      p.f-0.body <a target="_blank" href="https://www.moma.org/calendar/exhibitions/5056?locale=en"><i>The Redaction</i>: Titus Kaphar and Reginald Dwayne Betts</a>
      p.f-0.body.top Creative Direction: <a target="_blank" href="https://www.moma.org/interactives/exhibitions/2011/talktome/objects/140027/">Forest Young</a>
      p.f-0.body Typeface Design: <a target="_blank" href="https://mckltype.com">Jeremy Mickel</a>
      p.f-0.body.mobile Web Collaborator + Dev: <a target="_blank" href="https://www.wilmthoben.com">Wilm Thoben</a>
      p.f-0.body.desktop Web Collaborator + Development: <a target="_blank" href="https://www.wilmthoben.com">Wilm Thoben</a>
      p.f-0.body Python Scripting: <a target="_blank" href="http://roxaboxen.us">Graham Bradley</a>
      p.f-0.body Animations: <a target="_blank" href="http://dazzle.studio">Zipeng Zhu / Dazzle</a>
      p.f-0.body.top Special Thanks to Jocelyn Miller, Alex Sloane, Taja Cheek, and Emily Shoyer at MoMA, and Natalie Renee at Kaphar Studio.
    a.contact(href="mailto:info@redaction.us")
      h3.f-0 info@redaction.us
</template>

<script>
export default {
  name: "FontSlider",

  data() {
    return {};
  }
};
</script>

<style lang="sass">
@import '@/styles/_variables.sass'
.type-credits
  width: 100vw
  padding: 11rem 0
  h3
    margin-left: 7vw
    font-size: 5.2rem
    line-height: 5.67rem
    margin-bottom: 2.5rem
    @media only screen and (min-width: $m)
      margin-left: 11.52vw
  .contact
    margin-top: 2rem
    display: block
    @media only screen and (min-width: $m)
      margin-top: 4rem
    h3
      font-size: 1.6rem
      line-height: 2rem
      @media only screen and (min-width: $m)
        font-size: 5.2rem
        line-height: 5.67rem
  .credits
    margin-left: 7vw
    width: 80vw
    @media only screen and (min-width: $m)
      margin-left: 11.52vw
      width: 50vw
    p
      &.mobile
        display: block

        @media only screen and (min-width: $m)
          display: none
      &.desktop
        display: none
        @media only screen and (min-width: $m)
          display: block
    .top
      margin-top: 2rem
      @media only screen and (min-width: $m)
         margin-top: 3rem
</style>
